$(document).ready(function () {
  // Check if popup was shown in the last 24 hours
  const lastShown = localStorage.getItem('newsletterPopupShown');
  const now = new Date().getTime();

  if (!lastShown || now - lastShown > 86400000) {
    // Show popup after 1 second delay
    setTimeout(function () {
      $('#newsletter-popup').fadeIn();
      // Save current timestamp
      localStorage.setItem('newsletterPopupShown', now);
    }, 1000);
  }

  // Close the popup on close button or overlay click
  $('.newsletter-popup__close, .newsletter-popup__overlay').on('click', function () {
    $('#newsletter-popup').fadeOut();
  });
});
